import { IRefIds } from './refs';

// Map refs to their display labels
export const ConceptRefTypeLabels: Partial<Record<IRefIds, string>> = {
  [IRefIds.vocs]: 'Vocabulary',
  [IRefIds.panels]: 'Panel',
  [IRefIds.compounds]: 'Compound',
  [IRefIds.cultural]: 'Cultural Voc',
};

export function getConceptRefLabel(ref: number): string {
  return ConceptRefTypeLabels[ref as IRefIds] || 'Unknown';
}